module.exports = __webpack_public_path__ + "img/withJuno_logo.3f1b5538.svg";